import { GoabSpacer, GoabDetails, GoabContainer } from "@abgov/react-components";
import DisplayContent from "../../components/DynamicForm/Forms/DisplayContent";
import IndianRegistrationNumber from "./IndianRegistrationNumber";
import FNIHBNumber from "./FNIHBNumber"; 
import React from "react";

export const initializeFirstNationStatusDetailFields = (fields, data) => {
  fields['band'] = data['band'] ?? '';
  fields['family'] = data['family'] ?? '';
  fields['position'] = data['position'] ?? '';
  fields['FNIHB'] = data['FNIHB'] ?? '';
}

const FirstNationStatusDetail = ({
  form,
  getResourceValue,
  pageResourceKey,
  setFormData,
  isGenerator = false,
  showBorder = true
}) => {
  const getPageResourceValue = ({ key, pageResourceKey }) => {
    if (pageResourceKey) {
      key = key.replace("firstNationStatus", pageResourceKey);
    }

    return getResourceValue({ key });
  };

  const ContainerComponent = showBorder ? GoabContainer : React.Fragment;

  return (
    <ContainerComponent>
      {!isGenerator && (
        <>
          {getPageResourceValue({
            key: "RESOURCES@firstNationStatus.container.description",
            pageResourceKey,
          })}

          <GoabSpacer vSpacing="l" />
          
          <GoabDetails
            heading={getPageResourceValue({
              key: "RESOURCES@firstNationStatus.detail.heading",
              pageResourceKey,
            })}
          >
              <DisplayContent
                content={getPageResourceValue({
                  key: "RESOURCES@firstNationStatus.detail.content",
                  pageResourceKey,
                })}
              />
          </GoabDetails>
          <GoabSpacer vSpacing="xs" />
        </>
        )
      }

      <IndianRegistrationNumber
        form={form}
        getResourceValue={getResourceValue}
        setFormData={setFormData}
      />

      <GoabSpacer vSpacing="xl" />

      {!isGenerator &&
        <>
          <p>
            {getPageResourceValue({
              key: "RESOURCES@firstNationStatus.FNIHB.description",
              pageResourceKey,
            })}
          </p>

          <GoabSpacer vSpacing="m" />
        </>
      }

      <FNIHBNumber
        form={form}
        getResourceValue={getResourceValue}
        setFormData={setFormData}
      ></FNIHBNumber>
    </ContainerComponent>
  );
};

export default FirstNationStatusDetail;
